import React, { useEffect, useState } from "react";
import "./FeaturesSection.css";
// import power from "../../../../Assets/Images/Powerful.png";
// import cust from "../../../../Assets/Images/Cust.png";
// import device from "../../../../Assets/Images/device.png";
// import Security from "../../../../Assets/Images/secure.png";
// import vpn from "../../../../Assets/Images/vpn.png";
// import surd from "../../../../Assets/Images/surd.png";
import { getData } from "../../../../Services/Api";

export default function FeaturesSection() {
  const [featureContent, setFeatureContent] = useState([]);
  const colors = ["purple", "blue", "green", "green", "purple", "blue"];

  const getFeatureContent = async () => {
    const getDataResponse = await getData("get-feature-content");
    setFeatureContent(getDataResponse?.data?.data || []);
  };

  useEffect(() => {
    getFeatureContent();
  }, []);

  return (
    <div id="features" className="FeaturesSection">
      <div className="container py-4">
        <div className="row">
          <div className="headerIneer">
            <div className="main">
              <p className="paragraph1 py-3 pb-2 fs-5 fw-bold text-center">
                Features
              </p>
              <h1 className="fw-bold text-center">Why 123myVPN?</h1>
            </div>
          </div>
          <div className="row py-5 FeatureMobileRow">
            {featureContent?.map((content, index) => {
              const colorClass = colors[index % colors.length]; // Cycle through colors
              return (
                <div className="col-lg-4 py-3" key={content?.id}>
                  <div className={`card-custom w-100 h-100 ${colorClass}`}>
                    <div className="py-5 pb-4">
                      <img
                        src={content?.image_url}
                        className="img-fluid d-block m-auto "
                        alt={content?.title}
                      />
                      <h4 className="text-center py-4 pb-0">
                        {content?.title}
                      </h4>
                    </div>
                    <p className="text-center">{content?.description}</p>
                  </div>
                </div>
              );
            })}
            {/* <div className="col-lg-4 py-3">
              <div className="card-custom w-100 h-100 blue">
                <div className="py-5 pb-4">
                  <img
                    src={cust}
                    className="img-fluid d-block m-auto "
                    alt="d"
                  />
                  <h4 className="text-center py-4 pb-0">24/7 Customer support</h4>
                </div>
                <p className="text-center">
                Get customer support via live chat.
                </p>
              </div>
            </div>
            <div className="col-lg-4 py-3">
              <div className="card-custom w-100 h-100 green">
                <div className="py-5 pb-4">
                  <img
                    src={device}
                    className="img-fluid d-block m-auto "
                    alt="d"
                  />
                  <h4 className="text-center py-4 pb-0">Up to 5 Devices</h4>
                </div>
                <p className="text-center">
                Get simultaneous access to 5 devices with
only one subscription
                </p>
              </div>
            </div>
            <div className="col-lg-4 py-3">
              <div className="card-custom w-100 h-100 green">
                <div className="py-5 pb-4">
                  <img
                    src={Security}
                    className="img-fluid d-block m-auto "
                    alt="d"
                  />
                  <h4 className="text-center py-4 pb-0">Advanced Security</h4>
                </div>
                <p className="text-center">
                We won’t record IP addresses, accessed
websites, Browsing histories, VPN server
connections.
                </p>
              </div>
            </div>
            <div className="col-lg-4 py-3">
              <div className="card-custom w-100 h-100 purple">
                <div className="py-5 pb-4">
                  <img
                    src={vpn}
                    className="img-fluid d-block m-auto "
                    alt="d"
                  />
                  <h4 className="text-center py-4 pb-0">No Log VPN</h4>
                </div>
                <p className="text-center">
                We don’t monitor or record any data about
your internet traffic.
                </p>
              </div>
            </div>
            <div className="col-lg-4 py-3">
              <div className="card-custom w-100 h-100 blue">
                <div className="py-5 pb-4">
                  <img
                    src={surd}
                    className="img-fluid d-block m-auto "
                    alt="d"
                  />
                  <h4 className="text-center py-4 pb-0">Surf Anonymously</h4>
                </div>
                <p className="text-center">
                  Pay with cryptocurrency and keep your
  privacy protected.
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
